<template>
  <div class='EnbSlogan'
  :style="{
    backgroundImage: `url(${background})`,
    backgroundSize: `100% 100%`,
    color: Prefes.frentelojaCorFonte.color
  }">
    {{ text }}
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/mixins/api'
export default {
  name: 'EnbSlogan',
  mixins: [api],
  data () {
    return {
      background: '',
      text: ''
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['GetFrenteLojaSlogan'])
  },
  created () {
    this.GetFrenteLojaSlogan()
      .then(res => {
        this.text = res.text
        this.background = this.api + res.img
      })
  }
}
</script>

<style scoped>
.EnbSlogan {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30%;
  color: #000000;
  font-size: 60px;
  font-weight: bold;
}

@media (max-width: 500px) {
  .EnbSlogan {
    width: 90%;
    line-height: 60px;
    height: max-content;
    padding: 5%;
  }
}
</style>
